import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios';
import { API_URL, IMAGE_URL } from '../actions/constant';
import { geterrors, clearerror } from './errorReducer'
import { Loading } from 'notiflix/build/notiflix-loading-aio';
import { Confirm } from 'notiflix/build/notiflix-confirm-aio';
import { Language } from '../actions/language';




export const counterSlice = createSlice({
    name: 'crud',
    initialState: {
        list: null,
        loading: false,
        add: null,
        edit: null,
        deleteone: null,
        viewone: null,
        reduxname: null,
        setting: {},
        lang: Language["en"]
    },
    reducers: {
        listloading: (state, action) => {
            state.loading = action.payload
            state.list = null
            state.add = {}
            state.edit = {}
            state.deleteone = {}
            state.viewone = null
            state.reduxname = null
        },
        loading: (state, action) => {
            state.loading = true
        },
        stoploading: (state, action) => {
            state.loading = false
        },
        list: (state, action) => {
            state.list = action.payload.data
            state.loading = false
            state.reduxname = action.payload.reduxName

        },
        add: (state, action) => {
            state.add = action.payload
            state.loading = false

        },
        edit: (state, action) => {
            state.edit = action.payload
            state.loading = false

        },
        deleteone: (state, action) => {
            state.deleteone = action.payload
            state.loading = false

        },
        viewone: (state, action) => {
            state.viewone = action.payload
            state.loading = false

        },
        setsetting: (state, action) => {
            state.setting = action.payload

        },
        setlanguage: (state, action) => {
            state.lang = action.payload

        },
        clearOne: (state, action) => {
            state[action.payload] = null

        },
    },
})

export const { list, add, edit, deleteone, viewone, loading, listloading, stoploading, setsetting, setlanguage, clearOne } = counterSlice.actions

//API CALLS

export const listSetting = (endpoint, params) => dispatch => {
    var pleaseWaitTxt = localStorage.lang === "ar" ? "انتظر من فضلك..." : "Please Wait..."
    Loading.standard(pleaseWaitTxt, { messageColor: "#ff9400", svgColor: "#ff9400", svgSize: '50px', backgroundColor: 'rgba(255,255,255,1)', });

    axios.get(`${API_URL}${"/api/setting/"}${params ? params : "?"}`)
        .then(res => {
            dispatch(setsetting(res.data));
            document.title = res.data.appName;
            var link = document.querySelector("link[rel~='shortcut icon']");
            console.log("LINK RES", link)
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
            }
            link.href = IMAGE_URL + res.data.favicon;
            console.log("LINK RES", link)

            Loading.remove()
        })
        .catch(err => {
            console.log("err", err)
            Loading.remove()

            dispatch(geterrors(err.response.data))
        });
};

export const listData = (endpoint, params, reduxName) => dispatch => {
    dispatch(listloading(true));
    dispatch(clearerror())
    axios.get(`${API_URL}${endpoint}${params ? params : "?"}`)
        .then(res => {
            // dispatch(list(res.data));
            dispatch(list({ data: res.data, reduxName }));

        })
        .catch(err => {
            console.log("err", err)
            dispatch(stoploading())
            dispatch(geterrors(err.response.data))
        });
};

export const addData = (endpoint, data) => dispatch => {
    dispatch(loading(true));
    dispatch(clearerror())

    axios.post(API_URL + endpoint, data)
        .then(res => {
            dispatch(add(res.data));
        })
        .catch(err => {
            console.log("err", err)
            dispatch(stoploading())
            dispatch(geterrors(err.response.data))
        });
};
export const editData = (endpoint, data) => dispatch => {
    dispatch(loading(true));
    dispatch(clearerror())

    axios.post(API_URL + endpoint, data)
        .then(res => {
            dispatch(edit(res.data));
        })
        .catch(err => {
            console.log("err", err)
            dispatch(stoploading())
            dispatch(geterrors(err.response.data))
        });
};

export const deleteData = (endpoint, data) => dispatch => {

    var confirmText = localStorage.lang === "ar" ? "تأكيد" : "Confirm"
    var confirmSubText = localStorage.lang === "ar" ? "هل أنت متأكد أنك تريد الحذف؟" : "Are you sure you want to delete?"
    var currLanguage = localStorage.lang === "ar" ? "ar" : "en"
    Confirm.init({
        rtl: localStorage.lang === "ar"
    })

    Confirm.show(
        confirmText,
        confirmSubText,
        Language[currLanguage].yes,
        Language[currLanguage].no,
        () => {
            dispatch(loading(true));
            dispatch(clearerror())

            axios.post(API_URL + endpoint, data)
                .then(res => {
                    dispatch(deleteone(res.data));
                })
                .catch(err => {
                    console.log("err", err)
                    dispatch(stoploading())
                    dispatch(geterrors(err.response.data))
                });
        },
        () => {

        },
        {
        },
    );

};

export const viewoneData = (endpoint, data) => dispatch => {
    dispatch(loading(true));
    dispatch(clearerror())

    axios.post(API_URL + endpoint, data)
        .then(res => {
            dispatch(viewone(res.data));
        })
        .catch(err => {
            console.log("err", err)
            dispatch(stoploading())
            dispatch(geterrors(err.response.data))
        });
};


export default counterSlice.reducer
